export default IconProtocol => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-protocol" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M15 6l-7 12" />
  <path d="M20 6l-7 12" />
  <path d="M5 14v.015" />
  <path d="M5 10.015v.015" />
</svg>`;